// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const RiseAboveSection = () => {
//   const [activeImage, setActiveImage] = useState(1);

//   const backgrounds = {
//     1: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1500&q=80", // Aviation Training
//     2: "https://images.unsplash.com/photo-1504198266285-165a04f26c34?auto=format&fit=crop&w=1500&q=80", // Computer Training
//   };

//   return (
//     <section className="relative w-full h-screen overflow-hidden">
//       {/* Background Image with Smooth Transition */}
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={activeImage}
//           className="absolute inset-0 bg-cover bg-center transition-all duration-1000"
//           style={{
//             backgroundImage: `url(${backgrounds[activeImage]})`,
//           }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//         ></motion.div>
//       </AnimatePresence>

//       {/* Dark Overlay */}
//       <div className="absolute inset-0 bg-black/40"></div>

//       {/* Content */}
//       <div className="relative z-10 h-full flex flex-col items-center justify-start text-center px-6 pt-12 sm:pt-16">
//         {/* Heading */}
//         <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold uppercase">
//           <span className="text-[#012D6F]">Ready to rise above </span>
//           <span className="text-[#E43038]">gravity?</span>
//         </h2>

//         {/* Description */}
//         <p className="mt-3 text-sm sm:text-base md:text-lg text-[#012D6F] font-semibold max-w-2xl">
//           Fast-track your aviation journey with 4 Aviators where passion meets
//           precision, and your wings take shape.
//         </p>

//         {/* Two-column grid */}
//         <div className="mt-10 grid grid-cols-1 md:grid-cols-2 w-full max-w-6xl text-left border-t border-white/40">
//           {/* Left Section */}
//           <div
//             className={`relative p-8 sm:p-10 cursor-pointer transition-all duration-500 ${
//               activeImage === 1 ? "bg-black/30" : "bg-transparent hover:bg-black/20"
//             }`}
//             onClick={() => setActiveImage(1)}
//           >
//             <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase">
//               Aviation Training
//             </h3>
//             <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-md">
//               We provide both hands-on and computer-based training to accommodate
//               a variety of learning preferences and needs.
//             </p>
//             <button className="mt-5 px-4 py-2 bg-[#E43038] text-white text-sm font-semibold rounded hover:bg-[#c4272d] transition-all">
//               Learn More →
//             </button>

//             {/* Grid Line */}
//             <div className="absolute top-0 right-0 w-px h-full bg-white/30 hidden md:block"></div>
//           </div>

//           {/* Right Section */}
//           <div
//             className={`relative p-8 sm:p-10 cursor-pointer transition-all duration-500 ${
//               activeImage === 2 ? "bg-black/30" : "bg-transparent hover:bg-black/20"
//             }`}
//             onClick={() => setActiveImage(2)}
//           >
//             <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase">
//               Computer Based <br /> Training Course
//             </h3>
//             <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-md">
//               Interactive, animated lessons designed to enhance your learning
//               experience and increase your chances of success.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default RiseAboveSection;




// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const RiseAboveSection = () => {
//     const [activeImage, setActiveImage] = useState(1);

//     const backgrounds = {
//         1: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1500&q=80",
//         2: "https://images.unsplash.com/photo-1504198266285-165a04f26c34?auto=format&fit=crop&w=1500&q=80",
//     };

//     return (
//         <section className="relative w-full h-screen overflow-hidden">
//             {/* Smooth Background Transition */}
//             <AnimatePresence mode="wait">
//                 <motion.div
//                     key={activeImage}
//                     className="absolute inset-0 bg-cover bg-center"
//                     style={{
//                         backgroundImage: `url(${backgrounds[activeImage]})`,
//                     }}
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     exit={{ opacity: 0 }}
//                     transition={{ duration: 1 }}
//                 ></motion.div>
//             </AnimatePresence>

//             {/* Dark Overlay */}
//             <div className="absolute inset-0 bg-black/40"></div>

//             {/* Vertical Grid Lines */}
//             <div className="absolute inset-0 flex justify-between pointer-events-none z-10">
//                 {[...Array(5)].map((_, i) => (
//                     <div
//                         key={i}
//                         className="w-px h-full bg-white/20"
//                         style={{ backdropFilter: "blur(1px)" }}
//                     ></div>
//                 ))}
//             </div>

//             {/* White Rectangle Cutout Top */}
//             <div className="absolute top-0 left-0 w-full h-36 bg-white clip-path-topcut z-20"></div>

//             {/* Main Content (between center 2 grid lines) */}
//             <div className="relative z-30 flex flex-col items-center justify-start h-full px-6">
//                 {/* Heading + Description inside white area */}
//                 <div className="max-w-4xl text-center mb-8">
//                     <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold uppercase">
//                         <span className="text-[#012D6F]">Ready to rise above </span>
//                         <span className="text-[#E43038]">gravity?</span>
//                     </h2>
//                     <p className="mt-3 text-sm sm:text-base md:text-lg text-[#012D6F] font-semibold max-w-2xl mx-auto">
//                         Fast-track your aviation journey with 4 Aviators where passion meets
//                         precision, and your wings take shape.
//                     </p>
//                 </div>

//                 {/* Two-column Grid (Centered in middle two columns) */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 w-full max-w-5xl">
//                     {/* Left Block */}
//                     <div
//                         className={`relative p-8 sm:p-10 cursor-pointer transition-all duration-500 ${activeImage === 1 ? "bg-black/30" : "bg-transparent hover:bg-black/20"
//                             }`}
//                         onClick={() => setActiveImage(1)}
//                     >
//                         <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase">
//                             Aviation Training
//                         </h3>
//                         <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-md">
//                             We provide both hands-on and computer-based training to accommodate
//                             a variety of learning preferences and needs.
//                         </p>
//                         <button className="mt-5 px-4 py-2 bg-[#E43038] text-white text-sm font-semibold rounded hover:bg-[#c4272d] transition-all">
//                             Learn More →
//                         </button>

//                         {/* Divider Line */}
//                         <div className="absolute top-0 right-0 w-px h-full bg-white/30 hidden md:block"></div>
//                     </div>

//                     {/* Right Block */}
//                     <div
//                         className={`relative p-8 sm:p-10 cursor-pointer transition-all duration-500 ${activeImage === 2 ? "bg-black/30" : "bg-transparent hover:bg-black/20"
//                             }`}
//                         onClick={() => setActiveImage(2)}
//                     >
//                         <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase">
//                             Computer Based <br /> Training Course
//                         </h3>
//                         <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-md">
//                             Interactive, animated lessons designed to enhance your learning
//                             experience and increase your chances of success.
//                         </p>
//                     </div>
//                 </div>
//             </div>

//             {/* Clip Path Style */}
//             <style>{`
//   .clip-path-topcut {
//     clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
//   }`}
//             </style>
//         </section>
//     );
// };

// export default RiseAboveSection;




// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const RiseAboveSection = () => {
//   const [activeImage, setActiveImage] = useState(1);

//   const backgrounds = {
//     1: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1500&q=80",
//     2: "https://images.unsplash.com/photo-1504198266285-165a04f26c34?auto=format&fit=crop&w=1500&q=80",
//   };

//   // Grid line animation variant
//   const gridLineVariants = {
//     hidden: { opacity: 0, y: 40 },
//     visible: (i) => ({
//       opacity: 1,
//       y: 0,
//       transition: { delay: i * 0.2, duration: 0.6 },
//     }),
//   };

//   return (
//     <section className="relative w-full h-screen overflow-hidden">
//       {/* Smooth Background Transition */}
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={activeImage}
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url(${backgrounds[activeImage]})`,
//           }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//         ></motion.div>
//       </AnimatePresence>

//       {/* Dark Overlay */}
//       <div className="absolute inset-0 bg-black/40"></div>

//       {/* Animated Grid Lines */}
//       <div className="absolute inset-0 flex justify-between pointer-events-none z-10">
//         {[...Array(4)].map((_, i) => (
//           <motion.div
//             key={i}
//             className="w-px h-full bg-white/20"
//             variants={gridLineVariants}
//             initial="hidden"
//             whileInView="visible"
//             custom={i}
//             viewport={{ once: true, amount: 0.2 }}
//             style={{ backdropFilter: "blur(1px)" }}
//           ></motion.div>
//         ))}
//       </div>

//       {/* White Rectangle Cutout in Center Columns */}
//       <div className="absolute top-0 left-1/4 w-1/2 h-40 bg-white clip-path-topcut z-20 max-md:left-0 max-md:w-full"></div>

//       {/* Main Content (between center grid lines) */}
//       <div className="relative z-30 flex flex-col items-center justify-start h-full px-6 pt-20 sm:pt-24">
//         {/* Heading + Description inside white rectangle */}
//         <div className="max-w-4xl text-center mb-8">
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold uppercase">
//             <span className="text-[#012D6F]">Ready to rise above </span>
//             <span className="text-[#E43038]">gravity?</span>
//           </h2>
//           <p className="mt-3 text-sm sm:text-base md:text-lg text-[#012D6F] font-semibold max-w-2xl mx-auto">
//             Fast-track your aviation journey with 4 Aviators where passion meets
//             precision, and your wings take shape.
//           </p>
//         </div>

//         {/* Two-column Grid (centered content area) */}
//         <div className="grid grid-cols-1 md:grid-cols-2 w-full max-w-5xl">
//           {/* Left Block */}
//           <div
//             className={`relative p-8 sm:p-10 cursor-pointer transition-all duration-500 ${
//               activeImage === 1 ? "bg-black/30" : "bg-transparent hover:bg-black/20"
//             }`}
//             onClick={() => setActiveImage(1)}
//           >
//             <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase">
//               Aviation Training
//             </h3>
//             <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-md">
//               We provide both hands-on and computer-based training to accommodate
//               a variety of learning preferences and needs.
//             </p>
//             <button className="mt-5 px-4 py-2 bg-[#E43038] text-white text-sm font-semibold rounded hover:bg-[#c4272d] transition-all">
//               Learn More →
//             </button>

//             {/* Divider Line */}
//             <div className="absolute top-0 right-0 w-px h-full bg-white/30 hidden md:block"></div>
//           </div>

//           {/* Right Block */}
//           <div
//             className={`relative p-8 sm:p-10 cursor-pointer transition-all duration-500 ${
//               activeImage === 2 ? "bg-black/30" : "bg-transparent hover:bg-black/20"
//             }`}
//             onClick={() => setActiveImage(2)}
//           >
//             <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase">
//               Computer Based <br /> Training Course
//             </h3>
//             <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-md">
//               Interactive, animated lessons designed to enhance your learning
//               experience and increase your chances of success.
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Clip Path Style */}
//       <style>{`
//         .clip-path-topcut {
//           clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
//         }
//       `}</style>
//     </section>
//   );
// };

// export default RiseAboveSection;



import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import TrainingForm from "../Training/TrainingForm";

const RiseAboveSection = () => {
  const [activeImage, setActiveImage] = useState(1);

  const backgrounds = {
    1: "https://mhcockpit.com/Media/4%20Aviators/Home/aviation-training.jpg",
    2: "https://mhcockpit.com/Media/4%20Aviators/Home/computer-based-training.jpg",
  };

  // Grid container variant for staggered animation
  const gridContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  // Each grid line animation
  const gridLineVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  const [open, setOpen] = useState(false);

  return (
    <section className="relative w-full h-screen overflow-hidden">
      {/* Smooth Background Transition */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeImage}
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgrounds[activeImage]})`,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        ></motion.div>
      </AnimatePresence>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Animated Grid Lines */}
      <motion.div
        className="absolute inset-0 flex justify-between pointer-events-none z-10"
        variants={gridContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {[...Array(4)].map((_, i) => (
          <motion.div
            key={i}
            className="w-px h-full bg-white/20"
            variants={gridLineVariants}
            style={{ backdropFilter: "blur(1px)" }}
          ></motion.div>
        ))}
      </motion.div>

      {/* White Rectangle Cutout in Center Columns */}
      <div className="absolute top-0 left-[20%] right-[20%] h-40 bg-white clip-path-topcut z-20 max-md:left-0 max-md:w-full"></div>

      {/* Main Content (between center grid lines) */}
      <div className="relative z-30 flex flex-col items-center justify-start h-full px-6 pt-10">
        {/* Heading + Description inside white rectangle */}
        <div className="max-w-4xl text-center mb-8">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold uppercase">
            <span className="text-[#012D6F]">Ready to rise above </span>
            <span className="text-[#E43038]">gravity?</span>
          </h2>
          <p className="mt-3 text-sm sm:text-base md:text-lg text-[#012D6F] font-semibold max-w-2xl mx-auto">
            Fast-track your aviation journey with 4 Aviators where passion meets
            precision, and your wings take shape.
          </p>
        </div>

        {/* Two-column Grid (centered content area) */}
        <div className="grid grid-cols-1 md:grid-cols-2 w-full max-w-5xl">
          {/* Left Block */}
          <div
            className={`relative p-8 sm:p-10 cursor-pointer transition-all duration-500 ${activeImage === 1 ? "bg-black/30" : "bg-transparent hover:bg-black/20"
              }`}
            onClick={() => setActiveImage(1)}
          >
            <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase">
              Aviation Training
            </h3>
            <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-md">
              We provide both hands-on and computer-based training to accommodate
              a variety of learning preferences and needs.
            </p>
            <button onClick={() => setOpen(true)} className="mt-5 px-4 py-2 bg-[#E43038] text-white text-sm font-semibold rounded hover:bg-[#c4272d] transition-all">
              Learn More →
            </button>

            {/* Divider Line */}
            <div className="absolute top-0 right-0 w-px h-full bg-white/30 hidden md:block"></div>
          </div>

          {/* Right Block */}
          <div
            className={`relative p-8 sm:p-10 cursor-pointer transition-all duration-500 ${activeImage === 2 ? "bg-black/30" : "bg-transparent hover:bg-black/20"
              }`}
            onClick={() => setActiveImage(2)}
          >
            <h3 className="text-2xl sm:text-3xl font-bold text-white uppercase">
              Computer Based <br /> Training Course
            </h3>
            <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-md">
              Interactive, animated lessons designed to enhance your learning
              experience and increase your chances of success.
            </p>
            <button onClick={() => setOpen(true)} onClick={() => setOpen(true)} className="mt-5 px-4 py-2 bg-[#E43038] text-white text-sm font-semibold rounded hover:bg-[#c4272d] transition-all">
              Learn More →
            </button>
          </div>
        </div>
      </div>

      {/* Clip Path Style */}
      <style>{`
        .clip-path-topcut {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }
      `}</style>
      {/* Form Modal */}
      <div>
        <TrainingForm open={open} onClose={() => setOpen(false)} />
      </div>
    </section>
  );
};

export default RiseAboveSection;
